import React, { useEffect, useState } from "react";
import { logOut } from "../utils/utils";
import { Navigate } from "react-router-dom";

const Logout = () => {
    const [isLoggedOut, setIsLoggedOut] = useState(false);

    useEffect(() => {
        const performLogout = async () => {
            try {
                const success = await logOut();
                if (success) {
                    console.log("User successfully logged out.");
                } else {
                    console.warn("Logout failed. Maybe the user was not logged in.");
                }
            } catch (error) {
                console.error("An error occurred during logout:", error);
            }
            setIsLoggedOut(true);
        };

        performLogout();
    }, []);

    if (isLoggedOut) {
        return <Navigate replace to="/login" />;
    }

    return null;
};

export default Logout;
